export type RoleInSchool
  = 'Diretor(a) Geral'
  | 'Diretor(a) Administrativo(a)'
  | 'Diretor(a) Financeiro(a)'
  | 'Vice-Diretor'
  | 'Gestor Escolar'
  | 'Coordenador(a) Escolar'
  | 'Coordenador(a) Pedagógico(a)'
  | 'Coordenador(a) Acadêmico(a)'
  | 'Responsável Técnico TI'
  | 'Secretário(a) Escolar'
  | 'Professor(a)'
  | 'Pai, Mãe ou Responsável'
  | 'Aluno(a)'
  | 'Outros';


export const roleInSchoolOptions: RoleInSchool[] = [
  'Diretor(a) Geral',
  'Diretor(a) Administrativo(a)',
  'Diretor(a) Financeiro(a)',
  'Vice-Diretor',
  'Gestor Escolar',
  'Coordenador(a) Escolar',
  'Coordenador(a) Pedagógico(a)',
  'Coordenador(a) Acadêmico(a)',
  'Responsável Técnico TI',
  'Secretário(a) Escolar',
  'Professor(a)',
  'Pai, Mãe ou Responsável',
  'Aluno(a)',
  'Outros'
];
